
import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { X } from "lucide-react";

interface RejectReasonModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  providerName: string;
}

const RejectReasonModal = ({ isOpen, onClose, onConfirm, providerName }: RejectReasonModalProps) => {
  const [reason, setReason] = useState('');
  
  const handleSubmit = () => {
    if (!reason.trim()) return;
    onConfirm(reason);
  };
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-lg">
            Reject Listing: {providerName}
          </DialogTitle>
          <DialogDescription>
            Please provide a reason for rejection. This will be sent to the service provider.
          </DialogDescription>
        </DialogHeader>
        
        <div className="my-3">
          <Textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter rejection reason..."
            className="min-h-[120px]"
            autoFocus
          />
        </div>
        
        <DialogFooter className="gap-2 sm:justify-end">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleSubmit}
            disabled={!reason.trim()}
          >
            Confirm Rejection
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RejectReasonModal;
